<section class="section-home">
  <div class="grid">
    <div class="col-2">
      <img class="w-6 qms-logo" src="../../../../assets/images/dashboard-images/QMSLogo.svg" style="visibility: hidden">
    </div>
    <div class="col-8">
      <h2 class="qms-title">TeleSpecialists <br> Quality Management System</h2>
    </div>
    <!-- menu -->
    <div class="col-2">
      <button class="justify-content-end m-7 w-6" mat-icon-button [matMenuTriggerFor]="menu"
        aria-label="Example icon-button with a menu">
        <div class="marginAuto">
          <p-avatar [image]="profileImageUrl" styleClass="cursor-pointer" size="large" shape="circle"></p-avatar>
        </div>
      </button>
      <mat-menu class="bg-white" #menu="matMenu">
        <!-- <li mat-menu-item routerLink="/Home/Administration/Settings/RcaTree">
          <span>
            <mat-icon><i class="pi pi-sign-out"></i></mat-icon>
            <span>Admin</span>
          </span>
        </li> -->
        <li mat-menu-item (click)="logOut()">
          <span>
            <mat-icon><i class="pi pi-sign-out"></i></mat-icon>
            <span>Logout</span>
          </span>
        </li>
      </mat-menu>
    </div>
    <!-- menu -->
  </div>
  <div class="grid define-ac mt-4">

    <div class="col-3 col-offset-1">
      <div [ngStyle]="toggleMain ? {'z-index':'3'} : {'z-index':'1'}" class="define-title relative">Define
        <p class="define-text mt-0 overflow-x-hidden overflow-y-hidden">Feasible Standard Work, Program
          Goals, Industry Accepted Benchmark Standards</p>
      </div>
      <div *ngIf="toggleMain" (click)="togglemenu(this)" class="absolute dashboard-blur"></div>
      <div [ngStyle]="toggleMain ? {'z-index':'2'} : {'z-index':'1'}" class="define-group-image">
        <a (click)="togglemenu(this)"><img [ngClass]="toggleMain? 'active-img':''"
            class="define-box w-7 cursor-pointer animate__animated animate__zoomIn"
            src="/assets/images/dashboard-images/Define.svg"></a>
            <div *ngIf="isAccessToDefine">
        <ul *ngIf="toggleMain" class="absolute dash-hover">
          <li *ngIf="isAccessToPiTeam">
            <span class="flex" (click)="togglesubmenu(this)"><img
                src="../../../../assets/images/sidebar-icons/PITeam.svg" alt="">
              <p>PI Teams</p>
            </span>
            <ul *ngIf="toggleSubMenu" class="absolute dash-child">
              <li *ngIf="isAccessToRoleAssignment">
                <a class="no-underline" href="/Home/Define/RolesAssignment" target="_blank" >
                <span class="flex" routerLink="/Home/Define/RolesAssignment" (click)="  onContextMenu($event)"><img
                    src="../../../../assets/images/sidebar-icons/aasignrole.svg" alt="">
                  <p>Roles Assignment</p>
                </span>
              </a>
              </li>
              <li *ngIf="isAccessToUsers">
                <a class="no-underline" href="/Home/Define/Users" target="_blank" >
                <span class="flex" routerLink="/Home/Define/Users" (click)="  onContextMenu($event)"><img
                    src="../../../../assets/images/sidebar-icons/adduser.svg" alt="">
                  <p>Users</p>
                </span>
              </a>
              </li>
            </ul>
          </li>
          <li *ngIf="isAccessToFacilityBenchmarks">
            <a class="no-underline" href="/Home/Define/Facilities" target="_blank" >
            <span class="flex" routerLink="/Home/Define/Facilities" (click)="  onContextMenu($event)"><img
                src="../../../../assets/images/sidebar-icons/FacilityGoals.svg" alt="">
              <p>Facility Benchmarks</p>
            </span>
            </a>
          </li>
          <li *ngIf="isAccessToFacilitySpecs">
            <a class="no-underline" href="/Home/Define/FacilitySpecs" target="_blank" >
            <span class="flex" routerLink="/Home/Define/FacilitySpecs" (click)="  onContextMenu($event)"><img
                src="../../../../assets/images/sidebar-icons/facilityspec.svg" alt="">
              <p>Facility Specifics</p>
            </span>
          </a>
          </li>
          <li *ngIf="isAccessToStandardProcess">
            <a class="no-underline" href="/Home/Define/StandardProcess" target="_blank" >
            <span class="flex" routerLink="/Home/Define/StandardProcess" (click)="  onContextMenu($event)"><img
                src="../../../../assets/images/sidebar-icons/standardprocess.svg" alt="">
              <p>Standard Process</p>
            </span>
          </a>
          </li>
        </ul>
      </div>
      <div *ngIf="!isAccessToDefine">
        <ul *ngIf="toggleMain" class="absolute dash-hover">
          <li style="pointer-events: none;">
            <span class="flex"><img
                src="/assets/images/dashboard-images/Define.svg" alt="">
              <p style="color: rgb(251, 251, 22);">You don't have access to Define</p>
            </span>
          </li>
        </ul>
      </div>
      </div>

    </div>

    <div class="col-3 col-offset-1">
      <div [ngStyle]="toggleAnalyzeMain ? {'z-index':'3'} : {'z-index':'1'}" class="analyze-title relative">Analyze
        <p class="analyze-text mt-0  overflow-x-hidden overflow-y-hidden">Metric Outliers and Trends
          of Possible Performance Improvement, RCAs, case reviews</p>
      </div>
      <div *ngIf="toggleAnalyzeMain" (click)="toggleAnalyzeMenu(this)" class="absolute dashboard-blur"></div>
      <div [ngStyle]="toggleAnalyzeMain ? {'z-index':'2'} : {'z-index':'1'}" class="Analyze-group-image">
        <a (click)="toggleAnalyzeMenu(this)"><img [ngClass]="toggleAnalyzeMain? 'active-img':''"
            class="Analyze-box w-6 cursor-pointer animate__animated animate__zoomIn"
            src="/assets/images/dashboard-images/Analyze.svg"></a>
      <div *ngIf="isAccessToAnalyze">
        <ul *ngIf="toggleAnalyzeMain" class="absolute Analyzedash-hover">
          <li *ngIf="isAccessToFacilityPI">
            <a class="no-underline" href="/Home/Analyze/Facility-PI" target="_blank" >
            <span class="flex" routerLink="/Home/Analyze/Facility-PI" (click)="  onContextMenu($event)"><img
                src="../../../../assets/images/sidebar-icons/PI-icon.svg" alt="">
              <p>Facility-PI</p>
            </span>
          </a>
          </li>
          <li *ngIf="isAccessToRCA">
            <a class="no-underline" href="/Home/Analyze/Cases" target="_blank" >
            <span class="flex" routerLink="/Home/Analyze/Cases" (click)="  onContextMenu($event)"><img
                src="../../../../assets/images/sidebar-icons/analyzeCase.svg" alt="">
              <p>RCA</p>
            </span>
          </a>
          </li>
        </ul>
      </div>
      <div *ngIf="!isAccessToAnalyze">
        <ul *ngIf="toggleAnalyzeMain" class="absolute Analyzedash-hover">
          <li style="pointer-events: none;">
            <span class="flex" routerLink="/Home/Analyze/Facility-PI"><img
              src="/assets/images/dashboard-images/Analyze.svg">
              <p style="color: rgb(251, 251, 22);">You don't have access to Analyze</p>
            </span>
          </li>
        </ul>
      </div>
      </div>
    </div>

    <div class="col-3">
      <div [ngStyle]="toggleControlMain ? {'z-index':'3'} : {'z-index':'1'}" class="control-title relative">Control
        <p class="control-text mt-0  overflow-x-hidden overflow-y-hidden">Monitor the execution of <br>PI plans and
          countermeasures</p>
      </div>
      <div *ngIf="toggleControlMain" (click)="toggleControlMenu(this)" class="absolute dashboard-blur"></div>
      <div [ngStyle]="toggleControlMain ? {'z-index':'2'} : {'z-index':'1'}" class="control-group-image">
        <a (click)="toggleControlMenu(this)"><img [ngClass]="toggleControlMain? 'active-img':''"
            class="control-box w-6 cursor-pointer animate__animated animate__zoomIn"
            src="/assets/images/dashboard-images/Control.svg"></a>
      <div *ngIf="isAccessToControl" class="activeClass">
        <ul *ngIf="toggleControlMain" class="absolute Controldash-hover">
          <li *ngIf="isAccessToQMSReports">
                <span class="flex" (click)="toggleSubControlMenu(this)"><img src="../../../../assets/images/Report.svg" alt="">
                  <p>Reports</p>
                  </span>
                  <ul *ngIf="toggleSubControlMain" class="absolute control-child">
                    <li *ngIf="isAccessToMRS">
                      <a class="no-underline" href="/Home/Control/MRS" target="_blank" >
                      <span class="flex" routerLink="/Home/Control/MRS" (click)="  onContextMenu($event)"><img
                          src="../../../../assets/images/Stroke-Quality-Metric-Report.svg" alt="">
                        <p>90 Day MRS</p>
                      </span>
                    </a>
                    </li>
                    <li *ngIf="isAccessToStrokeQualityMetrics" >
                      <a class="no-underline" href="/Home/Control/StrokeQualityMetrics" target="_blank" >
                      <span class="flex" routerLink="/Home/Control/StrokeQualityMetrics" (click)="onContextMenu($event)"><img
                          src="../../../../assets/images/Patient-case-follow-up-report.svg" alt="">
                        <p>Stroke Quality Metrics</p>
                      </span>
                    </a>
                    </li>
                  </ul>
              </li>
              <li *ngIf="isAccessToRapidITrending">
                <a class="no-underline" href="/Home/Control/rapidiTrending" target="_blank" >
                <span class="flex" routerLink="/Home/Control/rapidiTrending" (click)="  onContextMenu($event)"><img
                    src="../../../../assets/images/rapidi-trending.svg" alt="">
                  <p>RAPIDi Trending</p>
                </span>
              </a>
              </li>
        </ul>
      </div>
      <div *ngIf="!isAccessToControl">
        <ul *ngIf="toggleControlMain" class="absolute Controldash-hover">
          <li style="pointer-events: none;">
            <span class="flex" routerLink="/Home/Analyze/Facility-PI"><img
              src="/assets/images/dashboard-images/Control.svg">
              <p style="color: rgb(251, 251, 22);">You don't have access to Control</p>
            </span>
          </li>
        </ul>
      </div>
      </div>
    </div>

  </div>

  <img class="zigzag-line" src="/assets/images/dashboard-images/zigzag.svg">
  <div class="grid">

    <div class="col-3 col-offset-3 text-center">
      <div *ngIf="toggleMeasureMain" (click)="toggleMeasureMenu(this)" class="absolute dashboard-blur"></div>
      <div [ngStyle]="toggleMeasureMain ? {'z-index':'2'} : {'z-index':'1'}" class="measure-group">
        <a (click)="toggleMeasureMenu(this)"><img [ngStyle]="toggleMeasureMain ? {'z-index':'5'} : {'z-index':'1'}"
            [ngClass]="toggleMeasureMain? 'active-img':''"
            class="relative measure-box w-6 cursor-pointer animate__animated animate__zoomIn"
            src="/assets/images/dashboard-images/Measure.svg"></a>
      <div *ngIf="isAccessToMeasure">
        <ul *ngIf="toggleMeasureMain" class="absolute Measuredash-hover">
          <li *ngIf="isAccessToCaseFollowUp">
            <a class="no-underline" href="/Home/Measures/Measures" target="_blank" >
            <span class="flex" routerLink="/Home/Measures/Measures" (click)="  onContextMenu($event)"><img
                src="../../../../assets/images/sidebar-icons/analyzeCase.svg" alt="">
              <p>Case Follow Up</p>
            </span>
          </a>
          </li>
        </ul>
      </div>
      <div *ngIf="!isAccessToMeasure">
        <ul *ngIf="toggleMeasureMain" class="absolute Measuredash-hover">
          <li style="pointer-events: none;">
            <span class="flex"><img
              src="/assets/images/dashboard-images/Measure.svg">
              <p style="color: rgb(251, 251, 22);">You don't have access to Measure</p>
            </span>
          </li>
        </ul>
      </div>
      </div>
      <div [ngStyle]="toggleMeasureMain ? {'z-index':'3'} : {'z-index':'1'}" class="measure-title relative">Measure
        <p class="measure-text mt-0">Service line-specific metrics</p>
      </div>
    </div>

    <div class="col-3 text-center">
      <div *ngIf="toggleImproveMain" (click)="toggleImproveMenu(this)" class="absolute dashboard-blur"></div>
      <div [ngStyle]="toggleImproveMain ? {'z-index':'2'} : {'z-index':'1'}" class="improve-group">
        <a (click)="toggleImproveMenu(this)"><img [ngStyle]="toggleImproveMain ? {'z-index':'5'} : {'z-index':'1'}"
            [ngClass]="toggleImproveMain? 'active-img':''"
            class="relative improve-box w-6 cursor-pointer animate__animated animate__zoomIn"
            src="/assets/images/dashboard-images/Improve.svg"></a>
      <div *ngIf="isAccessToImprove">
        <ul *ngIf="toggleImproveMain" class="absolute Improvedash-hover">
          <li *ngIf="isAccessToDefault">
            <a class="no-underline" href="/Home/Improve/Default" target="_blank" >
            <span class="flex" routerLink="/Home/Improve/Default" (click)="  onContextMenu($event)"><img
                src="../../../../assets/images/sidebar-icons/improve.svg" alt="">
              <p>PI Reports</p>
            </span>
          </a>
          </li>
        </ul>
      </div>
      <div *ngIf="!isAccessToImprove">
        <ul *ngIf="toggleImproveMain" class="absolute Improvedash-hover">
          <li style="pointer-events: none;">
            <span class="flex"><img
              src="/assets/images/dashboard-images/Improve.svg">
              <p style="color: rgb(251, 251, 22);">You don't have access to Improve</p>
            </span>
          </li>
        </ul>
      </div>
      </div>
      <div [ngStyle]="toggleImproveMain ? {'z-index':'3'} : {'z-index':'1'}" class="measure-title relative">Improve
        <p class="measure-text mt-0">Identification of Specific PI Plans<br>and Countermeasures</p>
      </div>
    </div>

  </div>
  <div class="grid">
    <div class="md:col-12 main-logo flex justify-content-end">
      <img src="../../../../assets/images/dashboard-images/mainPage.png" alt="">
    </div>
    <div class="footer-logo md:col-12 flex justify-content-end">
      <img class="mr-5" width="20%" src="../../../../assets/images/TS-Newlogo.png" alt="TeleSpecialists">
    </div>
  </div>

</section>
